import * as AdditionalServiceBannerStyles from './AdditionalServiceBanner.css';

export default {
	AdditionalServiceBannerStyles
};
